import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './../../../../core/services/auth.service';

@Component({
  selector: 'brn-widget-connection-modal',
  templateUrl: './widget-connection-modal.component.html',
  styleUrls: ['./widget-connection-modal.component.scss']
})
export class WidgetConnectionModalComponent implements OnInit {

  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  newConnection = true;

  positions = [
    {
      name: 'left',
      value: 'left'
    },
    {
      name: 'right',
      value: 'right'
    }
  ];

  widgetCode = '';

  settingData = {
    account_id: AuthService.getAccountId(),
    provider_data: {
      token: '',
      settings: {
        welcomeText: '',
        showWelcomeDelay: '',
        position: ''
      }
    }
  };

  widgetForm = this.formBuilder.group({
    welcomeText: ['', Validators.required],
    showWelcomeDelay: ['', Validators.required],
    position: ['', Validators.required],
    start_button: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<WidgetConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    private snackbar: MatSnackBar
  ) {
    if (data.providerData) {
      const providerData = data.providerData;
      this.newConnection = false;
      this.widgetForm.patchValue(providerData.settings);

      console.log(data);

      // const widgetUrl = getDomainData.host.search(/api-dev/i) == -1 ? 'https://test-widget.bots.work/widget/widget.js' : 'https://test-widget.bots.work/dev/widget.js';

      const widgetUrl = "https://test-widget.bots.work/widget/widget.js";

      this.widgetCode += "<script type=\"text/javascript\" charset=\"utf-8\">\n";
      this.widgetCode += "    var currentScript = document.currentScript;\n";
      this.widgetCode += "\n";
      this.widgetCode += "    window.addEventListener('load', function() {\n";
      this.widgetCode += "        var s = document.createElement('script');\n";
      this.widgetCode += "        s.src = '" + widgetUrl + "';\n";
      this.widgetCode += "        s.type = \"text/javascript\";\n";
      this.widgetCode += "        currentScript.parentNode.appendChild(s);\n";
      this.widgetCode += "\n";
      this.widgetCode += "        var w = document.createElement('chat-widget');\n";
      this.widgetCode += "        w.setAttribute(\"bot\", \"" + data.bot_id + "\");\n";
      this.widgetCode += "        w.setAttribute(\"token\", \"" + data.providerData.token + "\");\n";
      this.widgetCode += "        currentScript.parentNode.appendChild(w);\n";
      this.widgetCode += "    });\n";
      this.widgetCode += "<\/script>";

    }
  }

  ngOnInit(): void { }

  copyToClipboard(): void {
    this.clipboard.copy(this.widgetCode);
    this.snackbar.open('Copied to clipboard', '', {
      duration: 3000,
      panelClass: 'success',
    });
  }

  get validForm(): boolean {
    return this.widgetForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.widgetForm.value;

    this.store.dispatch(new CreateBotConnection('widget', { token: this.makeToken(), settings: providerData }));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.widgetForm.value;
    this.store.dispatch(new UpdateBotConnection('widget', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('widget'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  makeToken(): string {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 25; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }
}
